import { useaxios } from "../../../../utils/useaxios";
export default (employ_id, amount, dat, note, type, department_id) => setloading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    setloading(true);
    if (type == 'income') {
        useaxios('employ_income/create.php', { employ_income_type: 'other', employ_income_amount: amount, employ_income_note: note, employ_income_date: dat, employ_id, department_id }).then((res) => {
            console.log(res);
            if (res.status == "ok") {
            } else {
                // clear();
            }
            setloading(false);
        });
    } else {
        useaxios('employ_expense/create.php', { employ_expense_type: 'other', employ_expense_amount: amount, employ_expense_note: note, employ_expense_date: dat, employ_id, department_id }).then((res) => {
            console.log(res);
            if (res.status == "ok") {
            } else {
                // clear();
            }
            setloading(false);
        });
    }
}